import type {GroupField, KeyTextField} from '@prismicio/client'
import cn from 'classnames'
import type {
  PricingSectionSliceLargePrimaryFirstPackagePillsItem,
  PricingSectionSliceLargePrimarySecondPackageItem,
  PricingSectionSliceLargePrimaryThirdPackageItem,
  Simplify,
} from 'prismicio-types'
import {LargeModuleCard} from './LargeModuleCard'
import {PricingPill} from './PricingPill'

export const LargePackageSection = ({
  title,
  pills = [],
  items,
}: {
  title: KeyTextField
  pills: GroupField<Simplify<PricingSectionSliceLargePrimaryFirstPackagePillsItem>>
  items: GroupField<
    Simplify<PricingSectionSliceLargePrimarySecondPackageItem | PricingSectionSliceLargePrimaryThirdPackageItem>
  >
}) => (
  <div className="flex flex-col gap-6">
    <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:gap-8">
      <h4 className="text-[24px] font-medium leading-[normal] text-moss-black">{title}</h4>
      {pills.length > 0 && (
        <div className="flex flex-wrap items-center gap-2 lg:gap-3">
          {pills.map((pill, index) => (
            <PricingPill pill={pill} key={`pill-${index}`} />
          ))}
        </div>
      )}
    </div>
    <div className={cn('flex w-full gap-4 max-lg:flex-wrap', {})}>
      {items.map((item, index) => (
        <LargeModuleCard
          backgroundColor={item.background_color}
          sectionLength={items.length}
          item={item}
          index={index}
          key={`module-card-${index}`}
        />
      ))}
    </div>
  </div>
)
